<mat-tab-group mat-align-tabs="center" dynamicHeight animationDuration="0ms" color="accent">
    <mat-tab>
        <ng-template mat-tab-label> Calendar Events </ng-template>
        <app-category-events></app-category-events>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label> Hall Of Fame </ng-template>
        <app-category-hall-of-fame></app-category-hall-of-fame>
    </mat-tab>
</mat-tab-group>
